import styled from 'styled-components';

import { DEFAULT_PLACEMENT } from 'modules/placements/constants';
import { usePlacementSelectorContext } from 'modules/placements/context/PlacementSelectorContext';
import { SettingsSectionHeader } from 'modules/templateEditor/common';
import { DataFeedsFormSection } from 'modules/templateEditor/common/DataFeedsFormSection';
import { RawDataForm } from 'modules/templateEditor/common/RawDataForm';
import { spacing } from 'ui/theme';
import { DISPLAY_CONTENT } from '../constants';
import { ActionButtons, Body, CustomTextFields, MediaUrl, OpenAction, Title } from '../formFields';

const Section = styled.div`
  margin-top: ${spacing.double};
`;

const { behaviorHeader, contentHeader, customTextFieldsHeader } = DISPLAY_CONTENT.settings;

/** @note Which form fields show up dynamically changes based on the configuration of the placement selected for the template */
export const SettingsForm = () => {
  const { selectedPlacementDetails } = usePlacementSelectorContext();

  const {
    hasTitle,
    hasBody,
    hasMedia,
    hasDataFeeds,
    textFields,
    hasOpenAction,
    actionButtons,
    payload,
  } = selectedPlacementDetails ?? DEFAULT_PLACEMENT;

  const hasTextFields = !!textFields?.length;
  const hasActionButtons = !!actionButtons?.length;
  const hasRawJson = payload !== undefined;

  const hasContentFields = hasTitle || hasBody || hasMedia || hasDataFeeds;
  const hasBehaviorFields = hasOpenAction || hasActionButtons || hasRawJson;

  return (
    <>
      {hasContentFields && (
        <Section data-test="embedded-content-fields-section">
          <SettingsSectionHeader>{contentHeader}</SettingsSectionHeader>
          {hasTitle && <Title />}
          {hasBody && <Body />}
          {hasMedia && <MediaUrl />}
          {hasDataFeeds && <DataFeedsFormSection />}
        </Section>
      )}

      {hasTextFields && (
        <Section data-test="embedded-custom-text-fields-section">
          <SettingsSectionHeader>{customTextFieldsHeader}</SettingsSectionHeader>
          <CustomTextFields />
        </Section>
      )}

      {hasBehaviorFields && (
        <Section data-test="embedded-behavior-fields-section">
          <SettingsSectionHeader>{behaviorHeader}</SettingsSectionHeader>
          {hasOpenAction && <OpenAction />}
          {hasActionButtons && <ActionButtons />}
          {hasRawJson && <RawDataForm />}
        </Section>
      )}
    </>
  );
};
